/**
 * responsive_cards.js
 * Script pour améliorer la responsivité des cartes et badges dans l'interface
 */

class ResponsiveCards {
  constructor() {
    this.init();
  }

  init() {
    this.setupCardResponsiveness();
    this.setupBadgeLabels();
    this.setupCardClickHandlers();

    // Gérer les changements de taille d'écran
    window.addEventListener('resize', this.handleResize.bind(this));

    // Réinitialiser lors de la navigation Turbolinks
    document.addEventListener('turbolinks:load', () => {
      this.setupCardResponsiveness();
      this.setupBadgeLabels();
      this.setupCardClickHandlers();
    });
  }

  setupCardResponsiveness() {
    // Ajuster les espacements sur mobile
    const isMobile = window.innerWidth < 768;
    const cards = document.querySelectorAll('.card.bg-white.border-0');

    cards.forEach(card => {
      // Ajuster le padding sur mobile
      if (isMobile) {
        card.classList.add('p-2');
        card.classList.add('mb-2');
      } else {
        card.classList.remove('mb-2');
      }

      // Ajouter une transition pour les changements de hauteur
      card.style.transition = 'all 0.2s ease';
    });

    // Optimiser l'affichage des badges sur petit écran
    const badges = document.querySelectorAll('.badge.truncate-text, .badge.truncate-geo');
    badges.forEach(badge => {
      if (isMobile) {
        badge.style.maxWidth = '90px';
        // Ajouter un title pour voir le texte complet au survol
        if (!badge.getAttribute('title') && badge.textContent) {
          badge.setAttribute('title', badge.textContent.trim());
        }
      } else {
        badge.style.maxWidth = '120px';
      }
    });
  }

  setupBadgeLabels() {
    // Adapter les libellés sur mobile pour économiser de l'espace
    const isMobile = window.innerWidth < 768;
    if (!isMobile) return;

    const labels = document.querySelectorAll('.small-content span:first-child');
    labels.forEach(label => {
      // Raccourcir certains libellés sur mobile
      if (label.textContent === 'Mobile en semaine:') {
        label.textContent = 'Semaine:';
      } else if (label.textContent === 'Mobile weekend:') {
        label.textContent = 'Weekend:';
      } else if (label.textContent === 'Trafic de rebond:') {
        label.textContent = 'Rebond:';
      }
    });
  }

  setupCardClickHandlers() {
    // Ajouter des gestionnaires d'événements pour les cartes cliquables
    const clickableCards = document.querySelectorAll('.card.cursor-pointer[data-href]');
    clickableCards.forEach(card => {
      card.addEventListener('click', () => {
        const href = card.getAttribute('data-href');
        if (href) {
          window.location.href = href;
        }
      });

      // Ajouter l'effet de survol
      card.classList.add('hover-effect');
    });
  }

  handleResize() {
    // Réappliquer les ajustements responsifs lors du redimensionnement
    this.setupCardResponsiveness();
    this.setupBadgeLabels();
  }
}

// Exporter la classe
export default ResponsiveCards;

// Créer une instance automatiquement lorsque le script est chargé
window.responsiveCards = new ResponsiveCards();
